import request from '@/utils/request'
import { withErpOpenApiAction } from '@/utils/erpOpenApiContext'

const baseUrl = '/erp/stock'

export const pageStockBalance = params => request({
  url: baseUrl + '/balance/page',
  method: 'get',
  params: params || {}
})

/** 兼容旧页：仅取第一页最多 100 条 */
export const listStockBalance = params => pageStockBalance({
  ...(params || {}),
  pageNum: 1,
  pageSize: 100
}).then(res => ({
  ...res,
  data: (res.data && res.data.records) ? res.data.records : []
}))

export const exportStockBalance = params => request({
  url: baseUrl + '/balance/export',
  method: 'get',
  params: params || {},
  responseType: 'blob'
})

export const pageStockInventoryFlow = params => request({
  url: baseUrl + '/flow/list',
  method: 'get',
  params
})
export const listStockOpening = () => request({ url: baseUrl + '/opening/list', method: 'get' })
export const createStockOpening = data => request({ url: baseUrl + '/opening/create', method: 'post', data })

export const listOpeningDocuments = params => request({
  url: baseUrl + '/opening/document/list', method: 'get', params
})
export const getOpeningDocument = id => request({
  url: baseUrl + '/opening/document/detail', method: 'get', params: { id }
})
export const saveOpeningDocument = data => request({
  url: baseUrl + '/opening/document/save', method: 'post', data
})
export const auditOpeningDocument = id => request(withErpOpenApiAction('期初审核', {
  url: baseUrl + '/opening/document/audit', method: 'post', data: { id }
}))
export const reverseAuditOpeningDocument = id => request(withErpOpenApiAction('期初反审核', {
  url: baseUrl + '/opening/document/reverse-audit', method: 'post', data: { id }
}))
export const deleteOpeningDocument = id => request({
  url: baseUrl + '/opening/document/delete', method: 'post', data: { id }
})
export const openingSkuOptions = (warehouseId, keyword) => request({
  url: baseUrl + '/opening/sku-options', method: 'get', params: { warehouseId, keyword }
})

export const listStocktake = params => request({ url: baseUrl + '/stocktake/list', method: 'get', params })
export const getStocktake = id => request({ url: baseUrl + '/stocktake/detail', method: 'get', params: { id } })
export const stocktakeSnapshot = warehouseId => request({ url: baseUrl + '/stocktake/snapshot', method: 'get', params: { warehouseId } })
export const stocktakeSkuOptions = (warehouseId, keyword) => request({
  url: baseUrl + '/stocktake/sku-options', method: 'get', params: { warehouseId, keyword }
})
export const stocktakeResolveItems = (warehouseId, skuIds) => request({
  url: baseUrl + '/stocktake/resolve-items', method: 'post', data: { warehouseId, skuIds }
})
export const saveStocktake = data => request({ url: baseUrl + '/stocktake/save', method: 'post', data })
export const auditStocktake = (id, confirmLedgerChange) => request({
  url: baseUrl + '/stocktake/audit', method: 'post', data: { id, confirmLedgerChange: !!confirmLedgerChange }
})
export const reverseAuditStocktake = id => request({ url: baseUrl + '/stocktake/reverse-audit', method: 'post', data: { id } })
export const deleteStocktake = id => request({ url: baseUrl + '/stocktake/delete', method: 'post', data: { id } })

export const listStockProfit = params => request({ url: baseUrl + '/profit/list', method: 'get', params })
export const getStockProfit = id => request({ url: baseUrl + '/profit/detail', method: 'get', params: { id } })
export const listStockLoss = params => request({ url: baseUrl + '/loss/list', method: 'get', params })
export const getStockLoss = id => request({ url: baseUrl + '/loss/detail', method: 'get', params: { id } })
